import { setLocale } from "yup";

export default setLocale({
  mixed: {
    required: (obj) => {
      return `kolom '${obj.path}' wajib diisi`;
    },
  },
});
